// Test Environment
// export const api = ` https://qrapid.io/test/`;
export const api_V2 = `https://api.qrapid.io/qrapid/v2`;

// local Environment
export const api = `http://localhost:3005`;
// export const api_V2 = `http://localhost:3000`;

// Production Environment
// export const api = `https://qrapid.io/v1`;
// export const api_V2 = `https://qrapid.io/v2`;
